import { useState, useEffect, useCallback } from 'react';
import { NO_PREFRENCE } from '@constants/quiz';
import { emptyObject, emptyList } from '@constants/empty';
import isEmptyUtil from '@utils/isEmpty';

const useLanguage = ({
  content = emptyObject,
  defaultLanguage = NO_PREFRENCE,
  availableLanguages = emptyList
}) => {
  const [currentSelectedLanguage, setCurrentSelectedLanguage] =
    useState(defaultLanguage);
  const [allLanguages, setAllLanguages] = useState([]);

  const onLanuguageChange = useCallback((selectedLanguage = {}) => {
    if (!isEmptyUtil(selectedLanguage?.code)) {
      setCurrentSelectedLanguage(selectedLanguage);
    }
  }, []);

  useEffect(() => {
    const hasNoContent = isEmptyUtil(content[defaultLanguage.code]);

    const currentAvailableLanguages = availableLanguages.filter(({ code }) => {
      return !isEmptyUtil(content[code]);
    });

    setAllLanguages(currentAvailableLanguages);

    if (hasNoContent && currentAvailableLanguages.length) {
      setCurrentSelectedLanguage(currentAvailableLanguages[0]);
    } else {
      setCurrentSelectedLanguage(defaultLanguage);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [content, defaultLanguage.code, availableLanguages]);

  return {
    onLanuguageChange,
    currentLanguage: currentSelectedLanguage,
    contentLanguages: allLanguages
  };
};

export default useLanguage;
